export default "src/content/themes/association-wordpress-theme/img/d67e614b13ea6b4ce2d00bbfbf0dcacc.jpeg";